import { IDialogOptions } from './mng-dialog.types';

export const DIALOG_DATEN_INVALID_OPTIONS: IDialogOptions = {
  htmlContent: `
  Die Eingaben sind <strong>ungültig bzw. unvollständig</strong>!<br><br> Bitte um Korrektur!
`
};

export const DIALOG_DATEN_VERWERFEN_OPTIONS: IDialogOptions = {
  htmlContent: `Es wurden Daten eingegeben - Möchten Sie die Bearbeitung <strong>abbrechen</strong> und die Daten verwerfen?`
};

export const DIALOG_DATEN_NOT_DIRTY_OPTIONS: IDialogOptions = {
  htmlContent: `Die Eingabedaten wurden NICHT verändert!<br><br> Das Ausführen der Aktion ist nicht möglich`
};
